import { jsxs, jsx } from "react/jsx-runtime";
const IconNumberedListSvg = ({ title, titleId, ...props }) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    focusable: "false",
    fill: "currentColor",
    width: 16,
    height: 16,
    "aria-labelledby": titleId,
    ...props,
    children: [
      title ? /* @__PURE__ */ jsx("title", { id: titleId, children: title }) : null,
      /* @__PURE__ */ jsx("path", { d: "M5 5h2v6H5zM3.69 17.583l2.087-1.673c.558-.446.755-.671.755-.95 0-.22-.166-.476-.567-.476-.354 0-.656.263-.79.603l-1.426-.603C4.043 13.466 4.993 13 6.033 13c1.44 0 2.248.866 2.248 1.945 0 .709-.499 1.213-1.479 1.952l-.904.686H8.31V19H3.69v-1.417ZM19 9h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2Zm0 8h-7a1 1 0 1 1 0-2h7a1 1 0 1 1 0 2Z" })
    ]
  }
);
export {
  IconNumberedListSvg
};
